export const WALLET_PROVIDERS = [
  { value: "VODAFONE_CASH" as const, labelAr: "فودافون كاش", labelEn: "Vodafone Cash", prefix: "010" },
  { value: "ORANGE_CASH" as const, labelAr: "أورانج كاش", labelEn: "Orange Cash", prefix: "012" },
  { value: "ETISALAT_CASH" as const, labelAr: "اتصالات كاش", labelEn: "Etisalat Cash", prefix: "011" },
  { value: "WE_PAY" as const, labelAr: "وي باي", labelEn: "WE Pay", prefix: "015" },
] as const;

export type WalletProviderValue = (typeof WALLET_PROVIDERS)[number]["value"];
